<template>
    <div class="w-full text-black">
        <div class="pb-[18px] border-b flex items-end justify-between">
            <div>
                <h2 class="text-[20px] font-light">Signature</h2>
                <p class="text-[13px] font-extralight mt-2">La signature enregistré sera associé au documents signés</p>
            </div>

            <DialogRoot>
                    <DialogTrigger>
                        <button class="h-[36px] px-6 border font-light border-[#3c41e9] bg-[#3c41e9] text-white rounded-xl">Ajouter une signature</button>
                    </DialogTrigger>
                    <DialogPortal>
                        <DialogOverlay className="fixed z-[1000] inset-0 bg-[#00000044] data-[state=open]:animate-overlayShow"/>
                        <DialogContent className="fixed text-black p-0 overflow-hidden w-[40%] z-[1001] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
                            <div class="px-5 pt-8 pb-3">
                                <DialogTitle class="font-light">Créer une signature</DialogTitle>
                            </div>
                            <div class="p-5 flex flex-col">
                                <div class="flex gap-x-[12px] items-center mb-3">
                                    <span v-bind:class="getActiveClass('Dessiner')" v-on:click="selectBar('Dessiner')"><Sig :size="20" strokeWidth="1.3"/> Dessiner</span>
                                    <span v-bind:class="getActiveClass('Importer')" v-on:click="selectBar('Importer')"><ImageUp :size="20" strokeWidth="1.3"/> Importer</span>
                                </div>

                                <div v-if="isActiveVue('Dessiner')" class="h-[40vh] w-full flex flex-col">
                                    <div class="grow w-full bg-[#f6f6f6] flex items-center justify-center rounded-sm overflow-hidden">
                                        <Signature ref="signature" :value="[]" :width="550" :height="270" />
                                    </div>
                                    <div class="w-full flex justify-end text-[13px] font-light mt-3">
                                        <button class="py-2 px-5 flex items-center gap-x-[4px] hover:bg-gray-200 transition-all rounded-lg">
                                            <Trash :size="16" strokeWidth="1.3"/>
                                            Effacer
                                        </button>
                                    </div>
                                </div>

                                <div v-if="isActiveVue('Importer')" class="h-[40vh] w-full flex flex-col">
                                    <label for="img" class="size-full border border-dashed rounded-lg flex flex-col gap-y-1 items-center justify-center cursor-pointer transition-all hover:bg-gray-50">
                                        <template v-if="preview">
                                            <img :src="preview" class="size-full object-cover" alt="preview image">
                                        </template>
                                        <template v-else>
                                            <ImageUp :size="20" strokeWidth="1.3"/>
                                            <p class="text-[13px] font-light">Cliquer pour importer la signature</p>
                                        </template>
                                    </label>
                                    <input type="file" @change="addImage" name="img" id="img" accept=".png, .jpg, .jpeg" class="hidden">
                                </div>

                            </div>
                            
                            <div class="flex items-center justify-end px-5 py-5 gap-x-5">
                                <button v-on:click="submitfromImport" type="button" class="py-3 px-8 rounded-md text-white bg-[#5357ec]">
                                    <Loader2 v-if="send" class="animate-spin mx-auto"/>
                                    <span v-if="!send" class="font-light">Enregistrer ma signature</span>
                                </button>
                            </div>
                        </DialogContent>
                    </DialogPortal>
                </DialogRoot>
        </div>
        <div class="h-[70vh] w-full flex items-center justify-center">
            <div class="flex flex-col items-center gap-y-3">
                <p class="font-extralight">Aucune signature enregistré</p>
            </div>
        </div>
    </div>
</template>
<script>
import {
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from 'radix-vue';
import {Signature as Sig,ImageUp,Trash,Loader2} from "lucide-vue-next";
import API from '@/service/API';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import Signature from '@lemonadejs/signature/dist/vue';
export default {
    name:"UserSignature",
    components:{
        Sig,
        ImageUp,
        Trash,
        Signature,
        Loader2,
        DialogContent,
        DialogOverlay,
        DialogPortal,
        DialogRoot,
        DialogTitle,
        DialogTrigger,
    },
    data(){
        return {
            active: "Dessiner",
            file: null,
            preview: null,
            send: false
        }
    },
    methods:{
        getActiveClass(libelle){
            return `flex cursor-pointer items-center gap-x-[4px] font-extralight px-6 py-2 border-b hover:border-b-[#5357ec] hover:text-[#5357ec] ${libelle == this.active ? "text-[#5357ec] border-b-[#5357ec]" : "border-b-white"}`;
        },
        selectBar(libelle){
            this.active = libelle;
        },
        isActiveVue(libelle){
            return this.active === libelle;
        },
        addImage(e){
            if (!e.target.files?.[0]) return;
            this.file = e.target.files?.[0];
            const reader = new FileReader();
            reader.onload = (e) => {
                this.preview = e.target.result;
            };
            reader.readAsDataURL(e.target.files?.[0]);
        },
        getImageSignature(){
            if(this.$refs.signature.current.value.length == 0 ){
                return Swal.fire('Erreur!!!!',"Veuillez signer avant d'enregistré",'error');
            }
            const url = this.$refs.signature.current.getImage();
            // Convert base64 to a blob
            const cleanBase64 = url.split(',')[1];
            const mime = url.split(',')[0].split("/")[1].split(";")[0];
            const byteCharacters = atob(cleanBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/octet-stream' });
            // Convert blob to file
            const idImage = uuidv4();
            const filename = `signature-${idImage}.${mime}`;
            const file = new File([blob],filename,{type:blob.type});
            // Load formdata
            this.submitSignature(file)
        },
        submitfromImport(){
            if(this.active == "Dessiner"){
                this.getImageSignature()
            }else{
                if(!this.file) return Swal.fire('Erreur!!!!',"Veuillez ajouté votre signature",'error');
                this.submitSignature(this.file);
            }
        },
        submitSignature(file){
            const formData = new FormData();
            this.send = true;
            formData.append("signature",file);
            API.post("updateEmployee/"+localStorage.getItem("userId"),formData)
            .then((data)=>{
                if(data.data.status){
                    localStorage.setItem("signature",data.data.user.signature);
                    this.$refs.signature.current.value = [];
                    Swal.fire('Succès!!!!',"Signature enregistré",'succes')
                    
                }
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.send = false;
            });
        }
    }
}
</script>